import { theme } from '@styles/theme';

import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandJourneys(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.76894 2C8.17831 3.19899 10.0047 3.9225 12.0001 3.9225C13.9954 3.9225 15.8218 3.19899 17.2312 2.00001L19.1397 3.90856C17.2392 5.59257 14.739 6.615 12.0001 6.615C9.26109 6.615 6.76092 5.59257 4.86039 3.90855L6.76894 2Z"
        fill={theme.color.indigo400}
      />
      <path
        d="M17.2312 22C15.8218 20.801 13.9954 20.0775 12.0001 20.0775C10.0047 20.0775 8.17832 20.801 6.76895 22L4.8604 20.0914C6.76093 18.4074 9.2611 17.385 12.0001 17.385C14.739 17.385 17.2392 18.4074 19.1397 20.0914L17.2312 22Z"
        fill={theme.color.indigo400}
      />
      <path
        d="M2 17.2311C3.19899 15.8218 3.9225 13.9954 3.9225 12C3.9225 10.0046 3.19899 8.17826 2.00001 6.76889L3.90856 4.86034C5.59257 6.76086 6.615 9.26103 6.615 12C6.615 14.739 5.59257 17.2391 3.90855 19.1397L2 17.2311Z"
        fill={theme.color.indigo400}
      />
      <path
        d="M22 6.76887C20.801 8.17825 20.0775 10.0046 20.0775 12C20.0775 13.9954 20.801 15.8217 22 17.2311L20.0914 19.1397C18.4074 17.2391 17.385 14.739 17.385 12C17.385 9.26103 18.4074 6.76085 20.0914 4.86033L22 6.76887Z"
        fill={theme.color.indigo400}
      />
    </BaseIcon>
  );
}
